const aboutConfig = {
  aboutText1: `I'm a Fullstack Web Developer building both the front end and back end of Websites and Web Applications that contribute to the success of the overall product. Check out some of my work in the Projects section.`,

  aboutText2: `I'm open to job opportunities where I can contribute, learn, and grow. If you have a good opportunity that matches my skills and experience, don't hesitate to contact me.`,

  serviceList: [
    {
      title: "Frontend",
      description:
        "Interactive and Responsive UI developed at a professional level using modern frameworks.",
      icon: "icon-1",
    },
    {
      title: "Development",
      description:
        "High-quality development of APIs at the professional level.",
      icon: "icon-4",
    },
    {
      title: "Data Structure and Algorithms",
      description:
        "Mastering core programming languages and algorithms to deliver high-performance, efficient, and innovative software solutions.",
      icon: "icon-3",
    },
    {
      title: "Language",
      description:
        "Clean and Optimized Code written at a professional level following best practices",
      icon: "icon-2",
    },
    
    
  ],
  testimonialsList: [
    {
      avatar: "avatar-1",
      name: "Daniel Lewis",
      testimony: `Richard was hired to create a corporate identity. We were very pleased with the work done. She has a lot of
            experience and is very concerned about the needs of client.`,
    },
    {
      avatar: "avatar-2",
      name: "Jessica Miller",
      testimony: `Richard was hired to create a corporate identity. We were very pleased with the work done. She has a lot of
            experience and is very concerned about the needs of client.`,
    },
    {
      avatar: "avatar-3",
      name: "Emily Evans",
      testimony: `Richard was hired to create a corporate identity. We were very pleased with the work done. She has a lot of
            experience and is very concerned about the needs of client.`,
    },
    {
      avatar: "avatar-4",
      name: "Henry William",
      testimony: `Richard was hired to create a corporate identity. We were very pleased with the work done. She has a lot of
            experience and is very concerned about the needs of client.`,
    },
  ],
  clientsList: [
    {
      name: "default",
      logo: "logo-1-color.png",
      link: "https://www.google.com",
    },
    {
      name: "default",
      logo: "logo-2-color.png",
      link: "https://www.google.com",
    },
    {
      name: "default",
      logo: "logo-1-color.png",
      link: "https://www.google.com",
    },
    {
      name: "default",
      logo: "logo-1-color.png",
      link: "https://www.google.com",
    },
    {
      name: "default",
      logo: "logo-1-color.png",
      link: "https://www.google.com",
    },
    {
      name: "default",
      logo: "logo-1-color.png",
      link: "https://www.google.com",
    },
  ],
};

export default aboutConfig;
